// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledButton } from "@insite/mobius/Clickable";
import { infoCardStyles } from "@turnerBlueprint/App/Components/InfoCards/InfoCard";
import { color, linkArrowStyle, xScreen } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

infoCardStyles.wrapper = {
    css: css`
        display: flex;
        width: 100%;
        height: 100%;
        background-color: ${color("common.white")};
        @media print {
            page-break-inside: avoid;
        }
        ${({ imagePosition }: any) => {
            return css`
                flex-direction: ${imagePosition};
            `;
        }}
    `,
};
infoCardStyles.imageWrapper = {
    css: css`
        flex: 0 0 auto;
        max-height: 100%;
        overflow: hidden;
        > div {
            width: 100%;
        }
        ${({ imagePosition }: any) =>
            imagePosition === "column" || imagePosition === "column-reverse"
                ? css`
                      height: 165px;
                      width: 100%;
                      text-align: center;

                      ${xScreen("lte", "lg")} {
                          height: 140px;
                      }
                      ${xScreen("lte", "md")} {
                          height: 117px;
                      }
                      ${xScreen("lte", "xs")} {
                          height: 107px;
                      }
                  `
                : css`
                      width: 124px;
                      ${xScreen("lte", "md")} {
                          width: 106px;
                      }
                      ${xScreen("lte", "xs")} {
                          width: 0;
                          display: none;
                      }
                  `}
    `,
};
infoCardStyles.image = {
    css: css`
        width: 100%;
        height: 100%;
        object-fit: cover;
    `,
};

infoCardStyles.cardContentWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        flex: 1;
        padding: 12px;
    `,
};
infoCardStyles.title = {
    forwardAs: "h2",
    css: css`
        margin-bottom: 8px;
    `,
};
infoCardStyles.subtitle = {
    variant: "p",
    size: 14,
    css: css`
        margin-bottom: 16px;
        line-height: 22px;

        &:not(:has(+ ${StyledButton})) {
            margin-bottom: 0;
        }
    `,
};
infoCardStyles.smallLink = linkArrowStyle();
infoCardStyles.link = linkArrowStyle("large");
